import { createFileRoute } from "@tanstack/react-router";
import Home from "@/pages/site/Home";
import taxFormsAsset from "@/assets/heroes/hero-tax-forms.jpg.asset.json";

const heroBase = taxFormsAsset.url.split("?")[0];
const heroSrc = `${heroBase}?auto=format&fit=crop&q=70&w=1600`;
const heroSrcSet = [800, 1200, 1600, 2000]
  .map((w) => `${heroBase}?auto=format&fit=crop&q=70&w=${w} ${w}w`)
  .join(", ");

export const Route = createFileRoute("/")({
  head: () => ({
    links: [
      {
        rel: "preload",
        as: "image",
        href: heroSrc,
        imageSrcSet: heroSrcSet,
        imageSizes: "100vw",
        fetchpriority: "high",
      },
    ],
  }),
  component: () => <Home />,
});
